/**
 * A single client-side change.
 *
 * @public
 */
export class CrudEntryImpl {
    clientId;
    id;
    op;
    opData;
    previousValues;
    table;
    transactionId;
    metadata;
    static fromRow(dbRow) {
        const data = JSON.parse(dbRow.data);
        return new CrudEntryImpl(parseInt(dbRow.id), data.op, data.type, data.id, dbRow.tx_id, data.data, data.old, data.metadata);
    }
    constructor(clientId, op, table, id, transactionId, opData, previousValues, metadata) {
        this.clientId = clientId;
        this.id = id;
        this.op = op;
        this.opData = opData;
        this.table = table;
        this.transactionId = transactionId;
        this.previousValues = previousValues;
        this.metadata = metadata;
    }
    toJSON() {
        return {
            op_id: this.clientId,
            op: this.op,
            type: this.table,
            id: this.id,
            tx_id: this.transactionId,
            data: this.opData,
            old: this.previousValues,
            metadata: this.metadata
        };
    }
    equals(entry) {
        return JSON.stringify(this.toComparisonArray()) == JSON.stringify(entry.toComparisonArray());
    }
    /**
     * Generates an array for use in deep comparison operations
     */
    toComparisonArray() {
        return [
            this.transactionId,
            this.clientId,
            this.op,
            this.table,
            this.id,
            this.opData,
            this.previousValues,
            this.metadata
        ];
    }
}
//# sourceMappingURL=CrudEntry.js.map